import axios, { AxiosInstance } from 'axios';
import { ISession } from 'interfaces/auth';
import { ITenant } from 'interfaces/tenants';
import { getTenant } from 'services/tenants';

const apiMap = new Map<string, AxiosInstance>();

export const getAPI = () => {
  const tenant = getTenant();

  const api = apiMap.get(tenant.name) || generateAPI(tenant);
  apiMap.set(tenant.name, api);

  return api;
};

const generateAPI = (tenant: ITenant) =>
  axios.create({
    baseURL: tenant.apiUrl
  });

interface LoginProps {
  username: string;
  password: string;
}

interface RefreshProps {
  refreshToken: string;
}

interface GoogleProps {
  code: string;
  signupPage: string;
}

interface RequestMagicLinkProps {
  email: string;
}

interface ConsumeMagicLinkProps {
  token: string;
}

export const login = async ({
  username,
  password
}: LoginProps): Promise<ISession> => {
  const { data } = await getAPI().post('/admin/auth/login', {
    username,
    password
  });

  return {
    token: data.token,
    refreshToken: data.refresh_token
  };
};

export const refresh = async ({
  refreshToken
}: RefreshProps): Promise<ISession> => {
  const { data } = await getAPI().post('/admin/auth/refresh', {
    token: refreshToken
  });

  return {
    token: data.token,
    refreshToken: data.refresh_token
  };
};

export const google = async ({
  code,
  signupPage
}: GoogleProps): Promise<ISession> => {
  const { data } = await getAPI().post('/admin/auth/google', {
    code,
    signup_page: signupPage
  });

  return {
    token: data.token,
    refreshToken: data.refresh_token
  };
};

export const requestMagicLink = async ({
  email
}: RequestMagicLinkProps): Promise<void> => {
  await getAPI().post('/admin/auth/magic_link', {
    email
  });
};

export const consumeMagicLink = async ({
  token
}: ConsumeMagicLinkProps): Promise<ISession> => {
  const { data } = await getAPI().post('/admin/auth/magic_link/consume', {
    token
  });

  return {
    token: data.token,
    refreshToken: data.refresh_token
  };
};
